module.exports = __webpack_public_path__ + "img/draw-bg.70a2cf2a.svg";